import { footerStyles } from "@insite/content-library/Pages/Footer";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

footerStyles.page = {
    fullWidth: [true, true, true, true, true],
    css: css`
        margin-top: 60px;
        border-top: 4px solid ${getColor(colorStrings.commonGlobalIndustrialTaupe)};
    `,
};
